import { createApi } from '@reduxjs/toolkit/query/react';
import authedQuery from '@/services/authed.query';
import { AccessManifest } from '@/services/api.types';

const api = createApi({
  reducerPath: 'baseApi',
  baseQuery: authedQuery,
  endpoints: builder => ({
    // GET /api/v1/access — the caller's capability manifest (batch 001). Bearer
    // is injected by authedQuery. Consumed by the auth guard to source permissions.
    getAccess: builder.query<AccessManifest, void>({
      query: () => '/v1/access',
    }),
  }),
});

export const { useGetAccessQuery } = api;

export default api;
